import React, { Component } from "react";
import { withTranslation } from 'react-i18next';
import SweetAlert from "react-bootstrap-sweetalert";


export default class BaseView extends Component {

    constructor(props) {
        super(props);
    }

    componentWillReceiveProps(nextProps) {
      this.setState({
        editingIndex: nextProps.editingIndex,
        editingItem: nextProps.editingItem,
        isNew: false
      });
    }
  
    getSelected(options, value){
        if(value==null)
          return null;
        if (options==null)
          return null;
        for(let option of options) {
            if (option.value==value){
              return option;
            }
        };
        return null;
      }
  
    confirmDelete( title, onConfirm ){
        const { t } = this.props;
        this.setState({
        alert: (
            <SweetAlert
              warning
              customClass="custom-sweet-alert"
              style={{ display: "block" }}
              title={title}
              onConfirm={ onConfirm }
              onCancel={() => { 
                  this.setState({
                  alert: null
                  });
              }}
              confirmBtnBsStyle="info"
              cancelBtnBsStyle="danger"
              confirmBtnText={t("SI")}
              cancelBtnText={t("NO")}
              showCancel
            >
              {t("Sei sicuro?")}
            </SweetAlert>
        )
        });    
    }

    getExpansionName(type){
        const { params } = this.props;
        if (params && params.androsLiveParams.expansions && params.androsLiveParams.expansions[type])
          return params.androsLiveParams.expansions[type]['name']; 
        else
          return "";
      }
  



}

    



// WEBPACK FOOTER //
// ./src/views/Configurations/BaseView.jsx